export class GlobalConstants {
  public cultureCookieId: number = 0;

  public backupLanguageId: number = 0;

  public default_strings;

  public ssoActive: boolean;

  public ssoEnabled: boolean;

  public userSsoOnly: boolean;


}
